import React, { Fragment } from "react";

import "./ContentHeader.css";

const ContentHeader = (props) => (
  <Fragment>
    <div className="mn-content-page mn-content-page--plain mn-grid__row">
      <div className="mn-grid__col">
        <div className="mn-content-page__header">
          <span className="mn-content-page__header-action">
            {props.headerAction}
          </span>
          <span className="mn-content-page__header-desc">
            {props.headerDescription}
          </span>
        </div>
      </div>
    </div>
  </Fragment>
);

export default ContentHeader;
